import React from 'react';

const PricingPage = () => {
  return (
    <div className="card">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <h3>Pricing & Margins</h3>
        <button className="secondary">Add Tier</button>
      </div>
      <div className="filters">
        <div className="filter-row">
          <div><label>Category</label><input placeholder="Search category" /></div>
          <div><label>Tier</label><select><option>All</option><option>Wholesale</option><option>Retail</option></select></div>
        </div>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>Category</th>
            <th>Base Price</th>
            <th>Wholesale</th>
            <th>Margin</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>Men Shirts</td><td>{'\u20B9'}850</td><td>{'\u20B9'}740</td><td>13%</td></tr>
          <tr><td>Women Tops</td><td>{'\u20B9'}680</td><td>{'\u20B9'}590</td><td>13%</td></tr>
        </tbody>
      </table>
    </div>
  );
};

export default PricingPage;
